export interface AppLogoProps {
  size?: number;
  className?: string;
  white?: boolean;
}

export function AppLogo({
  size = 28,
  className = '',
  white = false,
}: AppLogoProps) {
  if (white) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="140 140 750 750"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        style={{ flexShrink: 0, display: 'block' }}
      >
        <defs>
          <clipPath id="app-logo-card-cutout" clipPathUnits="userSpaceOnUse">
            <path clipRule="evenodd" fillRule="evenodd" d="M 0 0 H 1200 V 1200 H 0 Z M 225 171 H 562 A 44 44 0 0 1 606 215 V 809 A 44 44 0 0 1 562 853 H 225 A 44 44 0 0 1 181 809 V 215 A 44 44 0 0 1 225 171 Z" />
          </clipPath>
        </defs>

        {/* Domino Tile (Tilted Daaluu domino tile behind playing card, clipped outside card) */}
        <g clipPath="url(#app-logo-card-cutout)">
          <g transform="translate(660 515) rotate(14.5)">
            {/* Domino outline */}
            <rect
              x="-135"
              y="-275"
              width="270"
              height="550"
              rx="40"
              stroke="#ffffff"
              strokeWidth="20"
              fill="none"
            />

            {/* Divider bar */}
            <rect x="-135" y="-6" width="270" height="12" fill="#ffffff" />

            {/* Top half: White pips (5-pip pattern) */}
            <circle cx="-68" cy="-195" r="26" fill="#ffffff" />
            <circle cx="68" cy="-195" r="26" fill="#ffffff" />
            <circle cx="0" cy="-135" r="26" fill="#ffffff" />
            <circle cx="-68" cy="-75" r="26" fill="#ffffff" />
            <circle cx="68" cy="-75" r="26" fill="#ffffff" />

            {/* Bottom half: White pips */}
            <circle cx="68" cy="85" r="26" fill="#ffffff" />
            <circle cx="68" cy="215" r="26" fill="#ffffff" />
            <circle cx="-68" cy="85" r="26" fill="#ffffff" />
            <circle cx="-68" cy="215" r="26" fill="#ffffff" />
          </g>
        </g>

        {/* Foreground Playing Card Outline */}
        <rect
          x="181"
          y="171"
          width="425"
          height="682"
          rx="44"
          stroke="#ffffff"
          strokeWidth="20"
          fill="none"
        />

        {/* Top Spade symbol */}
        <path
          className="app-logo-spade"
          d="M 393.5 238 C 400 274, 464 294, 464 336 C 464 364, 442 376, 418 374 C 402 373, 396 366, 395 372 C 398 386, 414 398, 418 404 H 369 C 373 398, 389 386, 392 372 C 391 366, 385 373, 369 374 C 345 376, 323 364, 323 336 C 323 294, 387 274, 393.5 238 Z"
          fill="#ffffff"
        />

        {/* Center '13' numeral */}
        <g className="app-logo-13" fill="#ffffff">
          {/* Digit 1 */}
          <path d="M 284 442 H 353 V 598 H 313 V 473 H 284 Z" />
          {/* Digit 3 */}
          <path d="M 379 442 H 490 V 468 L 452 516 H 488 C 498 528, 502 546, 497 560 C 490 580, 466 598, 432 598 C 398 598, 374 584, 374 568 C 374 558, 382 552, 386 552 H 396 C 404 558, 414 564, 430 564 C 448 564, 464 554, 464 538 C 464 524, 448 518, 430 518 H 413 V 498 L 444 468 H 379 Z" />
        </g>

        {/* Bottom Inverted Spade symbol */}
        <path
          className="app-logo-spade-bottom"
          d="M 393.5 238 C 400 274, 464 294, 464 336 C 464 364, 442 376, 418 374 C 402 373, 396 366, 395 372 C 398 386, 414 398, 418 404 H 369 C 373 398, 389 386, 392 372 C 391 366, 385 373, 369 374 C 345 376, 323 364, 323 336 C 323 294, 387 274, 393.5 238 Z"
          fill="#ffffff"
          transform="rotate(180 393.5 515)"
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="140 140 750 750"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      style={{ flexShrink: 0, display: 'block' }}
    >
      {/* Ground Shadows */}
      {/* Domino ground shadow */}
      <rect
        x="-135"
        y="-275"
        width="270"
        height="550"
        rx="40"
        fill="#d6d0c4"
        transform="translate(674 531) rotate(14.5)"
      />
      {/* Card ground shadow */}
      <rect
        x="195"
        y="187"
        width="425"
        height="682"
        rx="44"
        fill="#d6d0c4"
      />

      {/* Domino Tile (Tilted Daaluu domino tile behind playing card) */}
      <g transform="translate(660 515) rotate(14.5)">
        {/* Domino body */}
        <rect
          x="-135"
          y="-275"
          width="270"
          height="550"
          rx="40"
          fill="#1b2738"
        />

        {/* Divider bar */}
        <rect
          x="-135"
          y="-6"
          width="270"
          height="12"
          fill="#ffffff"
        />

        {/* Top half: White pips (5-pip pattern) */}
        <circle cx="-68" cy="-195" r="26" fill="#ffffff" />
        <circle cx="68" cy="-195" r="26" fill="#ffffff" />
        <circle cx="0" cy="-135" r="26" fill="#ffffff" />
        <circle cx="-68" cy="-75" r="26" fill="#ffffff" />
        <circle cx="68" cy="-75" r="26" fill="#ffffff" />

        {/* Bottom half: Red pips */}
        <circle cx="68" cy="85" r="26" fill="#c8102e" />
        <circle cx="68" cy="215" r="26" fill="#c8102e" />
        <circle cx="-68" cy="85" r="26" fill="#c8102e" />
        <circle cx="-68" cy="215" r="26" fill="#c8102e" />
      </g>

      {/* Card shadow on Domino */}
      <rect
        x="181"
        y="171"
        width="440"
        height="682"
        rx="44"
        fill="#121a25"
        opacity="0.35"
      />

      {/* Foreground Playing Card (13 / Big Two) */}
      {/* Dark card outer frame */}
      <rect
        x="181"
        y="171"
        width="425"
        height="682"
        rx="44"
        fill="#1b2738"
      />
      {/* Ivory card face */}
      <rect
        x="215"
        y="205"
        width="357"
        height="614"
        rx="24"
        fill="#fcfbfa"
      />

      {/* Top Spade symbol */}
      <path
        className="app-logo-spade"
        d="M 393.5 238 C 400 274, 464 294, 464 336 C 464 364, 442 376, 418 374 C 402 373, 396 366, 395 372 C 398 386, 414 398, 418 404 H 369 C 373 398, 389 386, 392 372 C 391 366, 385 373, 369 374 C 345 376, 323 364, 323 336 C 323 294, 387 274, 393.5 238 Z"
        fill="#10141a"
      />

      {/* Center '13' numeral */}
      <g className="app-logo-13" fill="#c8102e">
        {/* Digit 1 */}
        <path d="M 284 442 H 353 V 598 H 313 V 473 H 284 Z" />
        {/* Digit 3 */}
        <path d="M 379 442 H 490 V 468 L 452 516 H 488 C 498 528, 502 546, 497 560 C 490 580, 466 598, 432 598 C 398 598, 374 584, 374 568 C 374 558, 382 552, 386 552 H 396 C 404 558, 414 564, 430 564 C 448 564, 464 554, 464 538 C 464 524, 448 518, 430 518 H 413 V 498 L 444 468 H 379 Z" />
      </g>

      {/* Bottom Inverted Spade symbol */}
      <path
        className="app-logo-spade-bottom"
        d="M 393.5 238 C 400 274, 464 294, 464 336 C 464 364, 442 376, 418 374 C 402 373, 396 366, 395 372 C 398 386, 414 398, 418 404 H 369 C 373 398, 389 386, 392 372 C 391 366, 385 373, 369 374 C 345 376, 323 364, 323 336 C 323 294, 387 274, 393.5 238 Z"
        fill="#10141a"
        transform="rotate(180 393.5 515)"
      />
    </svg>
  );
}
